"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AuthState = require("../../AuthState");

var _AuthState2 = _interopRequireDefault(_AuthState);

var _callEach = require("../../utilities/callEach");

var _callEach2 = _interopRequireDefault(_callEach);

var _emcm = require("./api/emcm");

var _estore = require("../api/estore");

var _openHiddenIframe = require("./utilities/openHiddenIframe");

var _openHiddenIframe2 = _interopRequireDefault(_openHiddenIframe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultState = {
  authState: _AuthState2.default.UNKNOWN,
  itemsInCart: 0,
  userName: null,
  userFirstName: null
};

var EMCMLoginService = function () {
  function EMCMLoginService(config) {
    _classCallCheck(this, EMCMLoginService);

    this.onChangeCallbacks = [];
    this.state = _extends({}, defaultState);

    this.config = config;
  }

  /**
   * Login with JWT. Send a request to EMCM, using valid JWT from ID Service,
   * providing a transferToken to then login to legacy Tax site and eStore if
   * federate is true.
   */


  _createClass(EMCMLoginService, [{
    key: "loginWithJWT",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(jwt, federate) {
        var userLoginResponse, transferToken, promises;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _emcm.userlogin)(this.config.emcm.location, this.config.emcm.cors, jwt);

              case 2:
                userLoginResponse = _context.sent;
                transferToken = userLoginResponse.transferToken;

                if (!federate) {
                  _context.next = 7;
                  break;
                }

                promises = this.config.transferIframeLocations.map(function (url) {
                  return (0, _openHiddenIframe2.default)("" + url + transferToken);
                });
                return _context.abrupt("return", Promise.all(promises));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loginWithJWT(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return loginWithJWT;
    }()

    /**
     * Redirect to OnePass with the provided transfer token.
     */

  }, {
    key: "loginWithTransferToken",
    value: function loginWithTransferToken(transferToken) {
      var transferUrl = this.config.onepass.transferUrl;
      var transferTokenParam = "transferToken=" + encodeURIComponent(transferToken);

      window.location.replace("" + transferUrl + (transferUrl.includes("?") ? "&" : "?") + transferTokenParam);
    }

    /**
     * Pop the redirect URL from session storage, if one was set. `null` otherwise.
     */

  }, {
    key: "popLoginRedirectURL",
    value: function popLoginRedirectURL() {
      var redirectUrl = sessionStorage.getItem(this.config.redirectUrlSessionKey);

      if (!redirectUrl) {
        return null;
      }

      sessionStorage.removeItem(this.config.redirectUrlSessionKey);

      return redirectUrl;
    }

    /**
     * EMCM Log out. Send a request to EMCM, and when it completes, reset this
     * instance to its default state and trigger a change.
     */

  }, {
    key: "emcmLogout",
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _emcm.userlogout)(this.config.emcm.location, this.config.emcm.cors);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function emcmLogout() {
        return _ref2.apply(this, arguments);
      }

      return emcmLogout;
    }()

    /**
     * Initialize the object. Make calls to servers, and update the state based on responses.
     */

  }, {
    key: "activate",
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.fetchUserDetails();

              case 2:
                if (!(this.state.authState === _AuthState2.default.LOGGED_IN)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return this.fetchCartDetails();

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function activate() {
        return _ref3.apply(this, arguments);
      }

      return activate;
    }()

    /**
     * Fetch user details. Send a request to EMCM, to retrieve user details from
     * httpOnly cookie.
     */

  }, {
    key: "fetchUserDetails",
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var userDetails;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return (0, _emcm.getuserdetails)(this.config.emcm.location, this.config.emcm.cors);

              case 3:
                userDetails = _context4.sent;


                if (userDetails.loggedIn) {
                  this.state.authState = _AuthState2.default.LOGGED_IN;
                  this.state.userName = userDetails.userName;
                  this.state.userFirstName = userDetails.firstName;
                } else {
                  this.state = _extends({}, defaultState, {
                    authState: _AuthState2.default.LOGGED_OUT
                  });
                }
                _context4.next = 11;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);

                this.state = _extends({}, defaultState, {
                  authState: _AuthState2.default.LOGGED_OUT
                });

                throw _context4.t0;

              case 11:
                _context4.prev = 11;

                this.privateTriggerChange();
                return _context4.finish(11);

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7, 11, 14]]);
      }));

      function fetchUserDetails() {
        return _ref4.apply(this, arguments);
      }

      return fetchUserDetails;
    }()

    /**
     * Fetch cart details. Send a request to eStore, to retrieve current shopping
     * cart item count.
     */

  }, {
    key: "fetchCartDetails",
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var cartDetails;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return (0, _estore.cart)(this.config.estore.location);

              case 2:
                cartDetails = _context5.sent;


                this.state.itemsInCart = cartDetails.itemsInCart;
                this.privateTriggerChange();

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function fetchCartDetails() {
        return _ref5.apply(this, arguments);
      }

      return fetchCartDetails;
    }()

    /**
     * Trigger the login procedure. Likely, redirect to a OnePass login screen.
     */

  }, {
    key: "login",
    value: function login() {
      sessionStorage.setItem(this.config.redirectUrlSessionKey, window.location.href);

      window.location.replace(this.config.identityService.loginUrl);
    }

    /**
     * Logout. Call federatedLogout and logout of Hybris and Wordpress sites also.
     */

  }, {
    key: "logout",
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var promises;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.emcmLogout();

              case 2:
                promises = this.config.signoutIframeLocations.map(function (url) {
                  return (0, _openHiddenIframe2.default)(url);
                });
                _context6.next = 5;
                return Promise.all(promises);

              case 5:

                this.state = _extends({}, defaultState, {
                  authState: _AuthState2.default.LOGGED_OUT
                });

                this.privateTriggerChange();

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function logout() {
        return _ref6.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "onChange",
    value: function onChange(cb) {
      this.onChangeCallbacks.push(cb);
    }
  }, {
    key: "offChange",
    value: function offChange(cb) {
      if (this.onChangeCallbacks.includes(cb)) {
        this.onChangeCallbacks.splice(this.onChangeCallbacks.indexOf(cb), 1);

        return true;
      }

      return false;
    }
  }, {
    key: "privateTriggerChange",
    value: function privateTriggerChange() {
      (0, _callEach2.default)(this.onChangeCallbacks, this);
    }
  }, {
    key: "accountOverviewUrl",
    get: function get() {
      return this.config.site.accountOverviewUrl;
    }
  }, {
    key: "authState",
    get: function get() {
      return this.state.authState;
    }
  }, {
    key: "cartUrl",
    get: function get() {
      return this.config.estore.cartUrl;
    }
  }, {
    key: "itemsInCart",
    get: function get() {
      return this.state.itemsInCart;
    }
  }, {
    key: "logoutUrl",
    get: function get() {
      return this.config.emcm.logoutUrl;
    }
  }, {
    key: "loginUrl",
    get: function get() {
      return this.config.emcm.loginUrl;
    }
  }, {
    key: "userName",
    get: function get() {
      return this.state.userName;
    }
  }, {
    key: "userFirstName",
    get: function get() {
      return this.state.userFirstName;
    }
  }]);

  return EMCMLoginService;
}();

exports.default = EMCMLoginService;